import { Templates } from '../../compile';
import { ViewOptions } from '../../interfaces/options';

export const DefaultSectionViewOptions: ViewOptions = {
	template: Templates.layouts_section,
	navigationLayout: Templates.general_empty
};
